import { defineMessages } from 'react-intl';

export default defineMessages({
    policyPeriod: {
        id: 'ri.gateway.policyterms.Policy Period',
        defaultMessage: 'Policy Period'
    },
    policyNumber: {
        id: 'ri.gateway.policyterms.Policy #',
        defaultMessage: 'Policy #'
    },
    state: {
        id: 'ri.gateway.policyterms.State',
        defaultMessage: 'State'
    },
    totalClaims: {
        id: 'ri.gateway.policyterms.Total Claims',
        defaultMessage: 'Total Claims'
    },
    incurredLoss: {
        id: 'ri.gateway.policyterms.Incurred Loss',
        defaultMessage: 'Incurred Loss'
    },
    policyTermsTitle: {
        id: 'ri.gateway.policyterms.Title.Policy Terms',
        defaultMessage: 'Policy Terms'
    },
    injuryAnalysisTitle: {
        id: 'ri.gateway.policyterms.Title.Claims Analysis',
        defaultMessage: 'Claims Analysis'
    },
    lossRunsTitle: {
        id: 'ri.gateway.policyterms.Title.Loss Runs',
        defaultMessage: 'Loss Runs' 
    },
    lossRunsTitle: {
        id: 'ri.gateway.policyterms.Button.Generate Report',
        defaultMessage: 'Generate Report'
    },
    noPolicyTermsDirective: {
        id: 'ri.gateway.directives.PolicyTermsDirective.policyterms.There are no policy terms associated with this policy',
        defaultMessage: 'There are no policy terms associated with this policy'
    },
    noPolicyTermsDataLabel: {
        id: 'gateway.directives.PolicyTermsDirective.policyterms.No polciy terms data for this policy, check back again in the next',
        defaultMessage: 'No policy terms data for this policy, check back again in the next 24 hour'
    },    
    generateExplaination: {
        id: "ri.gateway.policyterms.Title.explaination",
        defaultMessage: "Select the desired policy years and press the Generate Report button"
    }
});
